module.exports = __webpack_public_path__ + "static/media/li.748d1f99.svg";